import React, { createContext, useContext } from 'react';
import { ISetting } from '@/interfaces/setting';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { querySettings } from '@/adapters/setting';
import Cookies from 'js-cookie';

interface CompanyContextType {
  setting?: ISetting;
}

const CompanyContext = createContext<CompanyContextType | undefined>(undefined);

export const CompanyProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const token = Cookies.get('access_token');
  const { data } = useQuery<AxiosResponse<ISetting>, Error>({
    queryKey: ['settings'],
    queryFn: async () => await querySettings(),
    enabled: !!token,
  });
  const setting = data?.data;
  return (
    <CompanyContext.Provider value={{ setting }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useSetting = (): CompanyContextType => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within an CompanyProvider');
  }
  return context;
};
